import React, { createContext, useContext, useState, useEffect } from 'react';

const NewFeaturesContext = createContext();

export const useNewFeatures = () => {
  const context = useContext(NewFeaturesContext);
  if (!context) {
    throw new Error('useNewFeatures must be used within a NewFeaturesProvider');
  }
  return context;
};

const NEW_FEATURES = {
  'context-spaces': {
    title: 'Context Spaces',
    description: 'Organize conversations by topics with resources like URLs, notes, and files. Perfect for project-specific discussions.'
  },
  'resources-section': {
    title: 'Resources',
    description: 'Add and manage websites, documents, and notes that will be available to the AI during your conversations.'
  },
  'add-resource': {
    title: 'Add Resources', 
    description: 'Click to add URLs, files, or text notes to your context space for richer AI conversations.'
  },
  'voice-chat': {
    title: 'Voice Chat',
    description: 'Have natural conversations using voice input and output. Perfect for hands-free interactions.'
  }
};

export const NewFeaturesProvider = ({ children }) => {
  const [usedFeatures, setUsedFeatures] = useState(() => {
    const saved = localStorage.getItem('usedNewFeatures');
    return saved ? JSON.parse(saved) : {};
  });

  const markFeatureAsUsed = (featureId) => {
    setUsedFeatures(prev => {
      const updated = { ...prev, [featureId]: true };
      localStorage.setItem('usedNewFeatures', JSON.stringify(updated));
      return updated;
    });
  };

  const isFeatureNew = (featureId) => {
    return !usedFeatures[featureId];
  };

  const getFeatureInfo = (featureId) => {
    return NEW_FEATURES[featureId] || { title: 'New Feature', description: 'This is a new feature.' };
  };

  const resetNewFeatures = () => {
    setUsedFeatures({});
    localStorage.removeItem('usedNewFeatures');
  };

  return (
    <NewFeaturesContext.Provider value={{
      markFeatureAsUsed,
      isFeatureNew,
      getFeatureInfo,
      resetNewFeatures,
      newFeatures: NEW_FEATURES
    }}>
      {children}
    </NewFeaturesContext.Provider>
  );
};

export default NewFeaturesProvider;